import english from '../locales/en/startup.json';
import spanish from '../locales/es/startup.json';

// This emergency screen must stay in the entry bundle. React, Shell, i18next,
// stylesheets, and image downloads may be the very resources that failed.
const messages = { en: english, es: spanish };
const isSupportedLanguage = (language) => Object.prototype.hasOwnProperty.call(messages, language);

const getLanguage = () => {
    const urlLanguage = (window.location.pathname.split('/')[1] || '').toLowerCase().split('-')[0];
    if (isSupportedLanguage(urlLanguage)) return urlLanguage;
    try {
        const savedLanguage = (window.localStorage.getItem('i18nextLng') || '').toLowerCase().split('-')[0];
        if (isSupportedLanguage(savedLanguage)) return savedLanguage;
    } catch {
        // Storage may be unavailable in an embedded LMS browser.
    }
    const browserLanguage = (window.navigator.language || '').toLowerCase().split('-')[0];
    return isSupportedLanguage(browserLanguage) ? browserLanguage : 'en';
};

export const renderStartupFailure = () => {
    const root = document.getElementById('root');
    if (!root) return;

    const language = getLanguage();
    const t = (key, fallback) => messages[language][key] || fallback;
    const screen = document.createElement('div');
    screen.className = 'tg-startup-failure';
    screen.lang = language;

    // Match Shell's palette, spacing, and focus treatment without loading it.
    const style = document.createElement('style');
    style.textContent = `
        .tg-startup-failure {
            min-height: 100vh; background: #fff; color: #222126;
            font: 500 16px/20px Inter, sans-serif; font-optical-sizing: none;
        }
        .tg-startup-failure header {
            padding: 20px 40px; border-bottom: 1px solid #d3d2d7;
            color: #6347ff; font-size: 20px; line-height: 24px;
        }
        .tg-startup-failure section {
            display: flex; flex-direction: column; align-items: center;
            gap: 24px; padding: 60px 20px; text-align: center;
        }
        .tg-startup-failure h1 {
            margin: 0; font-size: 42px; line-height: 52px;
            font-weight: 500; letter-spacing: -0.04em;
        }
        .tg-startup-failure p { margin: 0; max-width: 500px; color: #56545f; }
        .tg-startup-failure button {
            border: 0; border-radius: 40px; padding: 8px 16px; min-height: 36px;
            font: 600 14px/16px Inter, sans-serif; background: #6347ff;
            color: #fff; cursor: pointer;
        }
        .tg-startup-failure button:hover { background: #4136c0; }
        .tg-startup-failure button:focus-visible { outline: 3px solid #3a65dc; outline-offset: 4px; }
        @media (max-width: 767px) {
            .tg-startup-failure header { padding-inline: 20px; }
            .tg-startup-failure h1 { font-size: 28px; line-height: 36px; }
        }
    `;

    const header = document.createElement('header');
    header.textContent = 'TimelyGrader';
    const content = document.createElement('section');
    content.setAttribute('aria-labelledby', 'startup-failure-title');
    const title = document.createElement('h1');
    title.id = 'startup-failure-title';
    title.textContent = t('title', 'We Couldn’t Load TimelyGrader');
    const description = document.createElement('p');
    description.textContent = t('description', 'Check your internet connection and try again.');
    const retry = document.createElement('button');
    retry.type = 'button';
    retry.textContent = t('retry', 'Try Again');
    // Reload refreshes the entry/chunk URLs after deployments and preserves the
    // full LMS launch URL. Never automatically reload or bypass compatibility.
    retry.addEventListener('click', () => window.location.reload());

    content.appendChild(title);
    content.appendChild(description);
    content.appendChild(retry);
    screen.appendChild(style);
    screen.appendChild(header);
    screen.appendChild(content);
    root.textContent = '';
    root.appendChild(screen);
    retry.focus();
};
